import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import BasePrompt from 'components/base/prompt/BasePrompt';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import {
  CustomNumberInputWithUnit,
  CustomTitleLabel,
} from 'components/earning/CustomBaseComponments';
import { POINT_TO_CASH_CONVERT_RATE } from 'config/CustomEnums';
import { ToastType, defaultDelayTime } from 'models/NavBarModel';

import { createAction } from 'utils';

import './AdjustPrompt.scss';

function UseCashDollarPrompt({ show, setShow, customer = null }) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { customerDetail } = useSelector((state) => ({
    customerDetail: state.customerList?.customer,
  }));

  const [targetCustomer, setTargetCustomer] = useState();
  const [quantity, setQuantity] = useState();
  const [error, setError] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [manualDisableButton, setManualDisableButton] = useState(false);

  useEffect(() => {
    if (show) {
      setTargetCustomer(customer);
      setQuantity();
      setError({});
      setConfirm(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  useEffect(() => {
    if (
      show &&
      (customerDetail?.pk === targetCustomer?.pk || !targetCustomer?.pk)
    ) {
      setTargetCustomer(customerDetail);
    }
  }, [customerDetail]);

  const getConfirmButtonDisabledStatus = () => {
    if (confirm) {
      return false;
    }
    if (!targetCustomer?.pk || !quantity) {
      return true;
    }
    return false;
  };

  const disabledButton =
    getConfirmButtonDisabledStatus() || manualDisableButton;

  const otherBody = () => {
    if (confirm) {
      let secretMobile = '';
      if (
        targetCustomer?.mobilePhoneNumberCountryCode &&
        targetCustomer?.mobilePhoneNumberSubscriberNumber
      ) {
        if (targetCustomer?.mobilePhoneNumberCountryCode === '86') {
          secretMobile = `${targetCustomer?.mobilePhoneNumberSubscriberNumber.slice(
            0,
            3,
          )}****${targetCustomer?.mobilePhoneNumberSubscriberNumber.slice(
            7,
            11,
          )}`;
        } else {
          const mobileLength =
            targetCustomer?.mobilePhoneNumberSubscriberNumber.length;
          secretMobile = `${
            targetCustomer?.mobilePhoneNumberSubscriberNumber[0]
          }${'*'.repeat(mobileLength - 2)}${
            targetCustomer?.mobilePhoneNumberSubscriberNumber[mobileLength - 1]
          }`;
        }
      }
      let data = {
        targetCustomer: targetCustomer?.pk,
        membershipId: targetCustomer?.membershipId,
        mobileNumber: secretMobile
          ? `+${targetCustomer?.mobilePhoneNumberCountryCode} ${secretMobile}`
          : '-',
        quantity,
      };
      let fields = [
        [{ title: 'Membership ID', field: 'membershipId' }],
        [{ title: 'Mobile number', field: 'mobileNumber' }],
        [{ title: 'Cash dollar to be used', field: 'quantity' }],
      ];

      console.log('confirmed data', data);
      return (
        <>
          <div className="adjust-other-body-preview">
            <MembershipInfoCard
              title=""
              hideTitle={true}
              data={data}
              fields={fields}
            />
          </div>
        </>
      );
    }
    return (
      <>
        <div className="adjust-other-body">
          <CustomTitleLabel title="Balance" />
          <label className="help-message margin-right-10-percent">
            {parseInt(
              targetCustomer?.pointAccount?.balance /
                POINT_TO_CASH_CONVERT_RATE,
            )}{' '}
            cash dollar ({targetCustomer?.pointAccount?.balance} points)
          </label>
          <label className="tips-message">
            {POINT_TO_CASH_CONVERT_RATE} points = 1 cash dollar; 1 cash dollar
            can be used as HK$ 1.
          </label>

          <CustomNumberInputWithUnit
            title={'Will spend'}
            setValue={(value) => {
              if (value !== quantity) {
                setError({});
              }
              setQuantity(value);
            }}
            defaultValue={quantity}
            unit={'cash dollar'}
            errorId={'quantity'}
            error={error?.quantity}
            errorMessage={`${
              quantity * POINT_TO_CASH_CONVERT_RATE
            } points is required,  which exceed the current point(s) balance, please re-enter.`}
          />
        </div>
      </>
    );
  };

  const onClose = () => {
    if (confirm) {
      setConfirm(false);
      return;
    }
    setShow(false);
    setQuantity();
  };

  const showSuccessToast = () => {
    dispatch({
      type: 'navBars/updateState',
      payload: {
        saveDiscardToastShowing: {
          value: true,
          type: ToastType.operatedSuccessfully,
          delayTime: defaultDelayTime,
        },
      },
    });
  };

  return (
    <BasePrompt
      customClass={'use-cash-dollar-prompt-container'}
      show={show}
      closeAction={() => {
        onClose();
      }}
      leftButton={{
        text: 'Cancel',
        action: () => onClose(),
      }}
      rightButton={{
        text: 'Confirm',
        disabled: disabledButton,
        action: () => {
          setError({});
          setManualDisableButton(true);

          if (!confirm) {
            if (
              quantity * POINT_TO_CASH_CONVERT_RATE >
              targetCustomer?.pointAccount?.balance
            ) {
              setError({ quantity: 'not valid' });
              setManualDisableButton(false);
              return;
            }
            setConfirm(true);
            setManualDisableButton(false);
            return;
          }

          let requestData = {
            id: targetCustomer?.pk,
            useCashDollars: {
              value: quantity,
            },
          };
          dispatch(
            createAction('customerList/adjustCustomerRewards')({
              data: requestData,
              successCallback: () => {
                setManualDisableButton(false);
                setShow(false);
                showSuccessToast();
                history.push(location);
                if (targetCustomer?.pk) {
                  dispatch({
                    type: 'customerList/getOneCustomer',
                    payload: { id: targetCustomer?.pk },
                  });
                }
              },
              failureCallback: () => {
                setManualDisableButton(false);
              },
            }),
          );
        },
      }}
      title={confirm ? 'Confirmation' : 'Use cash dollar'}
      otherBody={otherBody}
    />
  );
}
export default UseCashDollarPrompt;
